import { useEffect, useState } from 'react';
import { WorkspaceAPI } from '../../../../../utils/api';
import { selfMember, sortMembers } from '../utils/peopleUtils';

export function usePeopleDirectory({
  workspaceId,
  isPersonal,
  user,
  myRole,
  mayManagePeople,
}) {
  const [members, setMembers] = useState([]);
  const [pending, setPending] = useState([]);
  const [listStatus, setListStatus] = useState('loading');

  useEffect(() => {
    if (isPersonal) {
      setMembers(selfMember(user, myRole === 'user' ? 'owner' : myRole));
      setPending([]);
      setListStatus('ready');
      return undefined;
    }

    let cancelled = false;
    setListStatus('loading');
    setMembers([]);
    setPending([]);

    WorkspaceAPI.members(workspaceId)
      .then((result) => {
        if (cancelled) return;
        const rows = Array.isArray(result?.members) ? result.members : [];
        const hasSelf = user?.sub && rows.some((r) => r.userId === user.sub);
        setMembers(sortMembers(hasSelf ? rows : [...selfMember(user, myRole), ...rows]));
        setListStatus('ready');
      })
      .catch((err) => {
        console.warn('Failed to load workspace members:', err?.message || err);
        if (cancelled) return;
        setMembers(selfMember(user, myRole));
        setListStatus('error');
      });

    if (mayManagePeople) {
      WorkspaceAPI.listInvites(workspaceId)
        .then((result) => {
          if (cancelled) return;
          setPending(Array.isArray(result?.invites) ? result.invites : []);
        })
        .catch((err) => {
          console.warn('Failed to load workspace invites:', err?.message || err);
          if (!cancelled) setPending([]);
        });
    } else {
      setPending([]);
    }

    return () => {
      cancelled = true;
    };
  }, [workspaceId, isPersonal, user?.sub, user?.email, myRole, mayManagePeople]);

  return { members, setMembers, pending, setPending, listStatus };
}
